import { formatDate } from "../../utils/utils";
import DataFormField from "../common/DataFormField";
import AuthSectionHeading from "./AuthSectionHeading";

const AuthDataFormSubSection = ({
  sectionHeading,
  sectionFields,
  formData,
  handleChange,
  handleBlur,
  errors = {},
  language = false,
}) => {
  const t = (val) =>
    typeof val === "object" ? (language ? val.hi : val.en) : val;
  return (
    <div className="flex flex-wrap mx-2">
      <AuthSectionHeading>{sectionHeading}</AuthSectionHeading>
      {sectionFields.map((field, index) => (
        <DataFormField
          key={index}
          lablelClass="text-md"
          divClass={field?.divClass}
          label={t(field?.label)}
          htmlFor={field?.htmlFor}
          error={errors[field.inputProps.name]}
          inputClass={
            field.inputProps.type === "checkbox"
              ? "h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              : "w-full border rounded px-3 py-2 text-sm"
          }
          inputProps={{
            required: field.inputProps.required || "false",
            type: field.inputProps.type || "text",
            name: field.inputProps.name,
            id: field.inputProps.name,
            placeholder: t(field.inputProps.placeholder),
            disabled: field.inputProps.disabled || false,
            value:
              field.inputProps.type === "date"
                ? formatDate(formData[field.inputProps.name])
                : field.inputProps.type === "checkbox"
                ? undefined // ✅ checkboxes don’t need value
                : formData[field.inputProps.name] || "",
            checked:
              field.inputProps.type === "checkbox"
                ? formData[field.inputProps.name] === true ||
                  formData[field.inputProps.name] === "1" ||
                  formData[field.inputProps.name] === 1
                : undefined,
            onChange: handleChange,
            onBlur: handleBlur,
            options: field.inputProps.options || [], // for dropdowns
            maxLength: field.inputProps.maxLength || 255,
            ...(field.inputProps.min ? { min: field.inputProps.min } : {}),
            ...(field.inputProps.max ? { max: field.inputProps.max } : {}),
            description: t(field.inputProps.description),
            formatDocument: field.inputProps.formatDocument || null,
          }}
          formData={formData}
          language={language}
        ></DataFormField>
      ))}
    </div>
  );
};

export default AuthDataFormSubSection;
